export default function getResource(label) {
    const resources = { qty: 'Quantity' };
    return resources[label];
}
